import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { Collection } from '../types';
import PublicIcon from '@mui/icons-material/Public';
import LockIcon from '@mui/icons-material/Lock';

interface CollectionInfoProps {
  collection: Collection;
}

const CollectionInfo: React.FC<CollectionInfoProps> = ({ collection }) => {
  return (
    <Box sx={{
      p: 2,
      mb: 3,
      bgcolor: '#f5f5f5',
      borderRadius: 1,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }}>
      <Box>
        <Typography variant="h6">
          Version: {collection.version}
        </Typography>
        {/* <Typography variant="body2" color="text.secondary">
          Collection ID: {collection._id}
        </Typography> */}
      </Box>

      <Chip
        icon={collection.isPublic ? <PublicIcon /> : <LockIcon />}
        label={collection.isPublic ? "Public" : "Private"}
        color={collection.isPublic ? "success" : "default"}
        variant={collection.isPublic ? "filled" : "outlined"}
      />
    </Box>
  );
};

export default CollectionInfo;